import { create } from 'zustand';
import { authApi } from '../api/auth';

export const useAuthStore = create((set, get) => ({
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  token: localStorage.getItem('token'),
  refreshToken: localStorage.getItem('refreshToken'),
  isAuthenticated: !!localStorage.getItem('token'),
  isLoading: false,
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const response = await authApi.login({ email, password });
      
      if (response.success && response.data && response.meta && response.meta.user) {
        const { access_token, refresh_token } = response.data;
        const user = response.meta.user;
        
        localStorage.setItem('token', access_token);
        localStorage.setItem('refreshToken', refresh_token);
        localStorage.setItem('user', JSON.stringify(user));
        
        set({
          user,
          token: access_token,
          refreshToken: refresh_token,
          isAuthenticated: true,
          isLoading: false
        });
      } else {
        throw new Error('Invalid login response');
      }
    } catch (error) {
      const detail = error.response?.data?.detail;
      const errorMessage = (typeof detail === 'object' ? detail?.message : detail) 
        || error.response?.data?.error?.message 
        || 'Login failed';
      set({ error: errorMessage, isLoading: false });
      throw error;
    }
  },

  register: async (email, password, firstName, lastName, companyName) => {
    set({ isLoading: true, error: null });
    try {
      const response = await authApi.register({
        email,
        password,
        first_name: firstName,
        last_name: lastName,
        company_name: companyName,
        role: 'analyst'
      });
      
      if (response.success) {
        await get().login(email, password);
      } else {
        throw new Error('Registration failed');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error?.message || 'Registration failed';
      set({ error: errorMessage, isLoading: false });
      throw error;
    }
  },

  logout: () => {
    const { refreshToken } = get();
    if (refreshToken) {
      authApi.logout(refreshToken).catch(() => {});
    }
    
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    
    set({
      user: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      error: null
    });
  },

  checkAuth: () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      set({
        token,
        user: JSON.parse(user),
        isAuthenticated: true
      });
    } else {
      set({
        token: null,
        user: null,
        isAuthenticated: false
      });
    }
  },

  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    set({ user });
  }
}));
